import type { Context, Provider } from 'react';
import { createContext, useContext } from 'react';
import type { CogI18nInstance } from '../../types/i18n';

type i18nInstanceType = CogI18nInstance<Record<string, string>> | null;
const TranslationContext: Context<i18nInstanceType> =
  createContext<CogI18nInstance<Record<string, string>> | null>(null);

export const TranslationContextProvider: Provider<i18nInstanceType> =
  TranslationContext.Provider;

export function useTranslationContext(): CogI18nInstance<
  Record<string, string>
> {
  const context = useContext(TranslationContext);
  if (context === null) {
    throw new Error(
      'useTranslationContext must be used inside TranslationContextProvider'
    );
  }
  return context;
}
